export default __webpack_public_path__ + "static/media/controle-alarme.ce36545f.png";